import Callout from './callout';
import EnhancedSeo from "../enhancedSeo";
var formHelpers = require('../util/formErrors');

class login {
  login() {
    $('form.login').submit((e) => {
      const form = $(e.currentTarget);
      e.preventDefault();
      var url = form.attr('action');
      var calloutMsg = null;

      if(form.parents('.mobile-login').length === 0){
        calloutMsg = form.attr('data-callout-msg');
      }

      form.hide();
      $('.login-spinner').show();
      // clean previous callout messages
      form.find('.callout').remove();

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: (data) => {
          if (data.success) {
            $.get(data.logOutUrl);

            EnhancedSeo.loginLogoutEvent('login', data.loyaltyLevel);

            // STEP 1 -- Retrieve the page action and define actions that should not trigger a page reload
            const pageElement = $('.js-page');
            const pageAction = pageElement.length > 0 ? pageElement.data('action') : null;
            const includeReloadActions = ['Product-Show', 'Search-Show', 'Home-Show', 'Page-Show', 'CustomerService-Show', 'BookAnAppointment-Show', 'Loyalty-ShowLanding', 'Wishlist-Show', 'Cart-Show'];

            // STEP 2 -- Check if the current page action is not in the excluded list
            if (includeReloadActions.includes(pageAction))
              location.reload();
            else if (data && data.redirectUrl)
              window.location.href = data.redirectUrl;

          } else {
            console.log(data);
            Callout.error(calloutMsg, data.error, form, true, true);
            $(form).find('.is-valid-label').addClass('is-invalid-label').removeClass('is-valid-label');
            $(form).find('[name*=loginPassword]').addClass('is-invalid-input').removeClass('is-valid-input');
            $(form).find('[name*=loginEmail]').addClass('is-invalid-input').removeClass('is-valid-input');
            $('.login-spinner').hide();
            form.show();
          }
        },
        error: (data) => {
          if (data.responseJSON.redirectUrl) {
            window.location.href = data.responseJSON.redirectUrl;
          } else {
            $('.login-spinner').hide();
            form.show();
          }
        }
      });
      return false;
    });

    $('form.login').find('.forgotpassword-link').on('click', (e) => {
      const _this = $(e.currentTarget);
      if (typeof window.sessionStorage !== 'undefined') {
        var insertedMail = _this.parents('form.login').find('[name="loginEmail"]').val();
        if (insertedMail) {
          window.sessionStorage.forgotPasswordMail = insertedMail;
        }
      }
    });
  }

  register() {
    $('form.registration').submit((e) => {
      var form = $(e.currentTarget);
      e.preventDefault();

      var url = form.attr('action');
      form.spinner().start();
      $('form.registration').trigger('login:register', e);

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          form.spinner().stop();
          // if (!data.success) {
          //     formValidation(form, data);
          // } else {
          //     location.href = data.redirectUrl;
          // }
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }

          form.spinner().stop();
        }
      });
      return false;
    });
  }

  resetPassword() {
    if (typeof window.sessionStorage !== 'undefined') {
      if (window.sessionStorage.forgotPasswordMail) {
        formHelpers.clearPreviousErrors($('#reset-password-form'));
        $('#reset-password-form').find('[name="loginEmail"]').val(window.sessionStorage.forgotPasswordMail);
        delete window.sessionStorage.forgotPasswordMail;
      }
    }

    $('.reset-password-form').submit(function (e) {
      var form = $(this);
      var formParent = form.parents('.forgot-password-modal')
      var calloutMsg = form.attr('data-callout-msg');

      e.preventDefault();
      var url = form.attr('action');

      if(formParent.length > 0){
        formHelpers.clearPreviousErrors(form);
        formParent.toggleClass('loading');
      } else {
        form.spinner().start();
      }
      $('.reset-password-form').trigger('login:register', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          if(formParent.length > 0) {
            formParent.toggleClass('loading');
          } else {
            form.spinner().stop();
          }

          if (!data.success) {
            if(formParent.length > 0){
              formHelpers.resetErrorList(form, data.error);
              formHelpers.loadFormErrors(form, data.error);
            }
          } else if (Object.prototype.hasOwnProperty.call(data, 'redirectUrl')) {
            if (data.redirectUrl) {
              window.location.href = data.redirectUrl;
            }
          } else {
            $('.request-password-title').text(data.receivedMsgHeading);
            $('.request-password-body').empty()
              .append('<p>' + data.receivedMsgBody + '</p>');
            if (!data.mobile) {
              $('#submitEmailButton').text(data.buttonText)
                .attr('data-dismiss', 'modal');
            } else {
              $('.send-email-btn').empty()
                .html('<a href="'
                                        + data.returnUrl
                                        + '" class="btn btn-primary btn-block">'
                                        + data.buttonText + '</a>');
            }
          }
        },
        error: function () {
          if(formParent.length > 0) {
            formParent.toggleClass('loading');
          } else {
            form.spinner().stop();
          }
        }
      });
      return false;
    });
  }

  clearResetForm() {
    $('#login .modal').on('hidden.bs.modal', function () {
      $('#reset-password-email').val('');
      $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
    });


  }
}

const Login = new login();
export default Login;



// WEBPACK FOOTER //
// ./assets/scripts/components/login.js